import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Tooltip,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ExpenseTable from "./expenseTable";
import { poNumberFormate, currencyFormate } from "jsFunctions/helperFunctions";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { useToasts } from "react-toast-notifications";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ProgressBar from "react-bootstrap/ProgressBar";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { MdModeEdit } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import { Button } from "react-bootstrap";
import VendorEditCreditForm from "views/admin/vendorDetail/creditModule/creditEditForm";
import { creditDataColumns } from "views/admin/vendorDetail/variable/variable";
import { fetchAsyncGetCreditDetailsByClientId } from "redux/creditSlice";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
const CreditDetails = ({ activeTab }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const currUser = useSelector((state) => state.auth.currUser);
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false); // Loading state

  const [role, setRole] = useState("");

  const [creditData, setCreditData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [creditColData, setCreditColData] = useState([]);
  const [creditSumarry, setCreditSummary] = useState({});
  const [client, setClient] = useState([]);
  const exportCreditList = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Client Credit Details");

      worksheet.columns = [
        { header: "No", key: "no", width: 8 },
        { header: "Credit No", key: "crNo", width: 20 },
        { header: "PO No", key: "poNo", width: 20 },
        { header: "Credit Date", key: "creditDate", width: 18 },
        { header: "Credit Amount", key: "creditAmount", width: 18 },
        { header: "Used Amount", key: "usedAmount", width: 18 },
        { header: "Remaining Amount", key: "remainingAmount", width: 20 },
        { header: "Utilization", key: "utilization", width: 15 },
      ];

      // Header Style
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = {
          bold: true,
          color: { argb: "FFFFFFFF" },
        };

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF4472C4" },
        };

        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
        };

        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });

      creditData.forEach((item, index) => {
        const remainingAmount =
          Number(item?.amt || 0) - Number(item?.usAmt || 0);

        const utilization = item?.amt
          ? `${((item.usAmt / item.amt) * 100).toFixed(0)}%`
          : "0%";

        const row = worksheet.addRow({
          no: index + 1,
          crNo: item?.crNo ? poNumberFormate(item.crNo) : "",
          poNo: item?.expPo || "-",
          creditDate: item?.pmtDt ? new Date(item.pmtDt) : "",
          creditAmount: Number(item?.amt || 0),
          usedAmount: Number(item?.usAmt || 0),
          remainingAmount,
          utilization,
        });

        if (item?.pmtDt) {
          row.getCell(4).numFmt = "dd-mmm-yyyy";
        }
      });

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;

        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            horizontal: typeof cell.value === "number" ? "right" : "left",
          };
        });
      });

      worksheet.getColumn("E").numFmt = "₹#,##0.00";
      worksheet.getColumn("F").numFmt = "₹#,##0.00";
      worksheet.getColumn("G").numFmt = "₹#,##0.00";

      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `${client?.clName}_Credit_${moment(new Date().getTime()).format("DD-MMM-YYYY")}.xlsx`,
      );
    } catch (error) {
      console.error(error);
      addToast("Failed to export credit details.", {
        appearance: "error",
      });
    }
  };

  useEffect(() => {
    if (currUser && currUser?.auth) {
      const auth = currUser?.auth;
      const roleObj =
        auth &&
        auth?.length > 0 &&
        auth.find((item) => item?.module === "Vendor");
      if (roleObj) {
        setRole(roleObj?.access);
      }
    }
  }, [currUser]);

  const fetchCreditDetails = async (clientId) => {
    setLoading(true);
    try {
      const res = await dispatch(
        fetchAsyncGetCreditDetailsByClientId(clientId),
      );
      if (res?.payload) {
        const creditDetail = res?.payload?.allCredit;
        const summaryData = res?.payload?.creditSummary;
        setCreditSummary(summaryData);
        setCreditData(creditDetail);
        setLoading(false);
        setClient(res?.payload?.client);
      }
    } catch (error) {
      setLoading(false);

      addToast(`Error fetching credit details:`, { appearance: "error" });
    }
  };

  useEffect(() => {
    if (id && activeTab === "creditDetails") {
      fetchCreditDetails(id);
    }
  }, [id, activeTab]);

  const [creditEditData, setCreditEditData] = useState(null);
  const [openCreditModal, setOpneCreditModal] = useState(false);

  const handleCloseModal = (active) => {
    setOpneCreditModal(false);
    setCreditEditData(null);
    fetchCreditDetails(id);
    setIsEdit(false);
  };

  const handleRowClick = (e, _id) => {
    e.stopPropagation();
    const data = creditData.filter((item) => item?._id === _id);
    setCreditEditData(data[0]);
    setOpneCreditModal(true);
    setIsEdit(true);
  };

  useEffect(() => {
    if (creditData && creditData.length > 0) {
      const tableData = creditData?.map((data, index) => {
        const remainingAmount = data?.amt - data?.usAmt;
        const percentageUsed = ((data?.usAmt / data?.amt) * 100).toFixed(0);
        return {
          _id: data._id,
          no: index + 1,
          crNo: (
            <span style={{ cursor: "pointer", color: "blue" }}>
              {data.crNo && poNumberFormate(data.crNo)}
            </span>
          ),
          poNo: <span className="blue">{data.expPo ? data.expPo : "-"}</span>,
          creditDate: (
            <span style={{ cursor: "pointer" }}>
              {dateTimeFormat(data?.pmtDt)}
            </span>
          ),

          sortTlAmt: Number(data?.amt || 0),
          creditAmount: (
            <span style={{ cursor: "pointer" }} className="blue">
              {data?.amt ? (
                currencyFormate(data?.amt)
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`,
                  }}
                />
              )}
            </span>
          ),
          sortUseAmt: Number(data?.usAmt || 0),
          usableAmount: (
            <span style={{ cursor: "pointer" }} className="gray">
              {data?.usAmt ? (
                currencyFormate(data?.usAmt)
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`,
                  }}
                />
              )}
            </span>
          ),
          sortRemAmt: Number(remainingAmount || 0),

          remainingAmount: (
            <span style={{ cursor: "pointer" }} className="green">
              {remainingAmount && remainingAmount >= 0 ? (
                currencyFormate(remainingAmount)
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`,
                  }}
                />
              )}
            </span>
          ),
          status: (
            <Box width={100}>
              <ProgressBar
                variant="success"
                now={percentageUsed}
                label={`${percentageUsed} %`}
              />
            </Box>
          ),
          actions: (
            <div className="d-flex">
              {role === "Admin" ? (
                <>
                  <MdModeEdit
                    className="me-2"
                    color="gray"
                    size={16}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      handleRowClick(e, data._id);
                    }}
                  />
                </>
              ) : (
                ""
              )}
            </div>
          ),
        };
      });
      setCreditColData(tableData);
    } else {
      setCreditColData([]);
    }
  }, [creditData]);

  if (loading) {
    return <SpinnerLoader />;
  }
  return (
    <Box>
      <Box className="ms-2 w-100 justify-content-end d-flex px-4 pt-2 pt-0">
        <Button variant="success" onClick={exportCreditList}>
          Export
        </Button>
      </Box>
      <Box display="flex" className="mx-0 expense_details">
        <Box className="expense_details_main">
          <Box className="acordian-box mt-1 ">
            <Accordion defaultIndex={[0]} allowMultiple>
              {/* All Expense Data Accordion */}
              <AccordionItem className="acordian-item" borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box display="flex" textAlign="left">
                      <Text fontWeight="600">Credit Amount Details </Text>
                      <Tooltip
                        label="Add New"
                        placement="top"
                        hasArrow
                        className="common-tooltip"
                      >
                        <Button
                          className="vendor-add-credit"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpneCreditModal(true);
                          }}
                        >
                          <FaPlus className="new-plus-icon1 mx-1" />
                        </Button>
                      </Tooltip>
                    </Box>
                    <Box
                      flex="1"
                      display="flex"
                      justifyContent="space-around"
                      alignItems="center"
                      flexDirection="row"
                    >
                      <Text className="mt-2" fontWeight="400">
                        Total Credit :{" "}
                        <span className="creditAmount blue">
                          ₹{" "}
                          {creditSumarry?.totalAmount
                            ? formatAmountIndianRupees(
                                creditSumarry?.totalAmount || 0,
                              )
                            : Number(0).toFixed(2)}
                        </span>{" "}
                      </Text>
                      <Text fontWeight="400">
                        Used Credit :{" "}
                        <span className="creditAmount gray">
                          ₹{" "}
                          {creditSumarry?.totalUsedAmount
                            ? formatAmountIndianRupees(
                                creditSumarry?.totalUsedAmount || 0,
                              )
                            : Number(0).toFixed(2)}
                        </span>{" "}
                      </Text>
                      <Text fontWeight="400">
                        Available Credit :{" "}
                        <span className="creditAmount green">
                          ₹{" "}
                          {creditSumarry?.totalRemainingAmount
                            ? formatAmountIndianRupees(
                                creditSumarry?.totalRemainingAmount || 0,
                              )
                            : Number(0).toFixed(2)}
                        </span>{" "}
                      </Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                  {creditColData && creditColData?.length > 0 ? (
                    <ExpenseTable
                      columnsData={creditDataColumns}
                      tableData={creditColData}
                      role={role}
                    />
                  ) : (
                    <Text className="py-3" fontWeight="600" textAlign="center">
                      There are no credit Amount
                    </Text>
                  )}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </Box>
        </Box>
        {openCreditModal && (
          <VendorEditCreditForm
            openModal={openCreditModal}
            closeModal={handleCloseModal}
            editData={creditEditData}
            isEdit={isEdit}
            clientId={id}
          />
        )}
      </Box>
    </Box>
  );
};

export default CreditDetails;
